import serverVars from 'server-vars';

export const initUnavailablePdpDatadogRum = (): void => {
    const datadog = serverVars.get('datadog');

    // @ts-ignore
    if (window.DD_RUM && datadog) {
        // @ts-ignore
        window.DD_RUM.onReady(function () {
            // @ts-ignore
            window.DD_RUM.init({
                applicationId: '7c81110a-02a8-4c4c-a562-9e6b0fee0774',
                clientToken: 'pub75f902898e739f952379c94bc7569846',
                site: 'datadoghq.com',
                env: datadog.env,
                service: 'app-buyer-finding-client',
                version: datadog.version,
                sessionSampleRate: 10,
                sessionReplaySampleRate: 0, // if not included, the default is 100
            });
        });
    }
};
